import { TournamentTeamSlot } from "@portal-frontend-ssr/blast-api";
import { useState } from "react";
import { TournamentTeam } from "~/components/TournamentTeam";

export const TournamentTeamsGrid = ({
  tournamentTeamSlots,
  disableLinkToTeamPage,
}: {
  tournamentTeamSlots: TournamentTeamSlot[];
  disableLinkToTeamPage?: boolean;
}) => {
  const [showAllLineups, setShowAllLineups] = useState(false);

  return (
    <>
      <div className="flex w-full flex-row items-center justify-between gap-1">
        <h2 className="font-style-label-l3">The Teams</h2>
        <div className="flex flex-row items-center justify-end gap-2">
          <span className="text-end font-style-label-l3">Show rosters</span>
          <div className="flex w-fit">
            {/* TODO: Remove this once the issue is fixed */}
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor="toggle" className="flex cursor-pointer items-center">
              <input
                type="checkbox"
                id="toggle"
                className="toggle-checkbox peer sr-only"
                onChange={() => setShowAllLineups((prev) => !prev)}
                checked={showAllLineups}
              />
              <div className="relative block h-6 w-11 rounded-full bg-background-90 p-1 before:absolute before:left-1 before:top-1/2 before:size-4 before:-translate-y-1/2 before:rounded-full before:bg-white before:p-1 before:transition-all before:duration-500 peer-checked:before:left-6 peer-checked:before:bg-primary-100"></div>
            </label>
          </div>
        </div>
      </div>

      {tournamentTeamSlots.length ? (
        <div className="grid w-full max-w-8xl auto-rows-fr grid-cols-4 gap-1">
          {Array.from({ length: tournamentTeamSlots.length }).map((_, index) => {
            const slot: TournamentTeamSlot | undefined = tournamentTeamSlots?.[index];

            return (
              <TournamentTeam
                key={index}
                tournamentTeamSlot={slot}
                showLineup={showAllLineups}
                disableLinkToTeamPage={disableLinkToTeamPage}
              />
            );
          })}
        </div>
      ) : (
        <p className="mb-2 flex h-10 items-center justify-center rounded-small bg-background-95 px-2 text-center text-white font-style-label-l3 md:h-16 md:px-4">
          Teams coming soon
        </p>
      )}
    </>
  );
};
